import React from "react";

const Idle = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M3.343 22.662V8.213c.002-1.14.626-1.949 1.675-2.17.177-.037.365-.041.548-.041C13.836 6 22.106 5.999 30.376 6c1.333 0 2.218.848 2.22 2.15.006 4.757.002 9.515.001 14.272 0 .073-.01.146-.016.24H3.343ZM30.865 7.657H5.082v13.675h25.783V7.657ZM17.95 26.157c5.098 0 10.196.002 15.294-.003.336 0 .607.072.717.415.033.105.06.249.015.337-.51.993-1.188 1.818-2.348 2.1-.28.068-.576.1-.866.1-8.486.006-16.971.004-25.457.005-1.229 0-2.158-.528-2.812-1.544-.15-.234-.303-.47-.428-.717-.173-.342.01-.649.398-.688.107-.011.216-.005.325-.005H17.95ZM3.33 23.282h29.229c.199 1.132-.733 2.212-1.956 2.285-.097.006-.195.005-.292.005H5.631c-1.176 0-2.01-.611-2.24-1.649-.044-.196-.04-.401-.061-.64Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M15.112 13.184c0-.494-.004-.974.001-1.454a2.783 2.783 0 0 1 2.798-2.775 2.786 2.786 0 0 1 2.786 2.757c.008.49.001.98.001 1.478.15.022.278.035.405.06.431.084.63.37.603.801-.024.383-.014.768-.014 1.153-.002 1.175.004 2.35-.003 3.525-.003.572-.35.93-.927.933-1.925.008-3.85.008-5.776 0-.579-.003-.929-.355-.931-.928a448.667 448.667 0 0 1 0-4.582c.002-.6.272-.843 1.057-.967Zm4.536.01c0-.642.073-1.278-.018-1.89-.112-.756-.908-1.314-1.673-1.307-.769.009-1.552.584-1.652 1.333-.082.605-.017 1.23-.017 1.864h3.36Zm-2.504 2.867c.061.166.074.397.195.486.281.209.235.476.238.746.002.127-.038.279.017.377.076.133.212.29.345.315.113.02.29-.109.377-.219.066-.085.047-.243.05-.37.006-.323-.028-.63.251-.909.245-.245.189-.687-.021-.947-.207-.256-.574-.35-.91-.233-.321.112-.502.378-.542.754Z"
            fill={fill}
        />
    </svg>
);

export default Idle;